import * as PIXI from "pixi.js";
import Layers from "../layers/Layers";
import TextureManager from "../managers/TextureManager";
import { LOGO_BOUNDS } from "../types/Config";

const LOGO_PATH = "/logo-small.png";

export default class Logo extends PIXI.Sprite {
  private Layers: Layers = Layers.getInstance();
  constructor() {
    super();
    Object.assign(this, LOGO_BOUNDS);
    this.anchor.set(.5);
    this.texture = TextureManager.getTexture(LOGO_PATH);
    this.Layers.VideoMode.addChild(this);
  }
}